import { createFileRoute } from "@tanstack/react-router";
import { CategoricalStandardsPage } from "@/components/categorical-standards/categorical-standards-page";

export const Route = createFileRoute("/_authenticated/categorical-standards")({
  component: CategoricalStandardsPage,
});
